import React, { useState, useContext } from 'react';
import { AuthContext } from 'AuthContext';
import LogoHome from './LogoHome';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login, globalError, setGlobalError } = useContext(AuthContext);
  const [error, setError] = useState(null);
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetMessage, setResetMessage] = useState(null);
  const [resetError, setResetError] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const success = await login(username, password);
      if (!success) {
        setError("Invalid credentials 😢");
      }
    } catch (err) {
      setError("Failed to connect to the server");
    }
  };

  const handleReset = async e => {
    e.preventDefault();
    setResetMessage(null);
    setResetError(null);
    try {
      const response = await fetch(`${API_URL}/api/reset-password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: resetEmail })
      });
      if (response.ok) {
        setResetMessage("A password reset email has been sent if this address matches a known account");
      } else {
        setResetError("Failed to request password reset. Please check the email address");
      }
    } catch (err) {
      setResetError("Error while requesting password reset");
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f8fafc">
      <Paper elevation={3} sx={{ p: 4, minWidth: 350 }}>
        <LogoHome size={110} />
        <Typography variant="h5" align="center" gutterBottom>
          IMMOOVA
        </Typography>
        {(error || globalError) && (
          <Alert severity="error">
            {error || globalError}
          </Alert>
        )}
        {showReset ? (
          <Box component="form" onSubmit={handleReset}>
            <TextField
              label="E-Mail Address"
              type="email"
              margin="normal"
              fullWidth
              sx={{ width: 1 }}
              value={resetEmail}
              onChange={e => setResetEmail(e.target.value)}
              required
            />
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
              Reset Password
            </Button>
            <Button onClick={() => setShowReset(false)} variant="text" fullWidth sx={{ mt: 1 }}>
              Back to Login
            </Button>
            {resetMessage && <Alert severity="success">{resetMessage}</Alert>}
            {resetError && <Alert severity="error">{resetError}</Alert>}
          </Box>
        ) : (
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              label="Username"
              margin="normal"
              fullWidth
              sx={{ width: 1 }}
              value={username}
              onChange={e => {
                setUsername(e.target.value);
                setGlobalError(null);
              }}
              required
            />
            <TextField
              label="Password"
              margin="normal"
              type="password"
              fullWidth
              sx={{ width: 1 }}
              value={password}
              onChange={e => {
                setPassword(e.target.value);
                setGlobalError(null);
              }}
              required
            />
            <Button variant="contained" color="primary" fullWidth type="submit" sx={{ mt: 2 }}>
              Login
            </Button>
            <Typography variant="body2" align="center" sx={{ mt: 2 }}>
              <Button onClick={() => setShowReset(true)} variant="text">
                Forgotten Password ?
              </Button>
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
}
export default Login;